import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import RequestForm from './components/RequestForm';
import BandLeader from './components/BandLeader';
import Queue from './components/Queue';
import Login from './components/Login';
import MusicDatabase from './components/MusicDatabase';
import LyricsDisplay from './components/LyricsDisplay';
import UserManagement from './components/UserManagement';
import BackgroundCycle from './components/BackgroundCycle';
import NotFound from './components/NotFound';
import NotificationSettings from './components/NotificationSettings';


function App() {
  return (
    <Router>
      <BackgroundCycle />
      <Routes>
        <Route path="/bandleader" element={<BandLeader />} />
        <Route path="/notifications" element={<NotificationSettings />} />
        <Route path="/queue" element={<Queue />} />
        <Route path="/" element={<RequestForm />} />
        <Route path="/login" element={<Login />} />
        <Route path="/musicdatabase" element={<MusicDatabase />} />
        <Route path="/lyrics/:songId" element={<LyricsDisplay />} />
        <Route path="/usermanagement" element={<UserManagement />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;